import { JoinData } from './JoinDataInt';

const navButtonHeight = 25;
const navButtonY = 747;

const pinpadHeight = 88;
const pinpadWidth = 88;

const row1Y = 277;
const row2Y = 375;
const row3Y = 473;
const row4Y = 571;
const column1X = 550;
const column2X = 648;
const column3X = 746;

const actionButtonHeight = 58;
const actionButtonY = 26;

const statusWidth = 285;

const securitySystem: JoinData[] = [
    { join: "digital-press-505", name: "Back", x: 129, y: 32, width: 53, height: 36, category: "security_system" },

    { join: "digital-feedback-137", name: "System Visibility", x: 583, y: navButtonY, width: 60, height: navButtonHeight, category: "security_system" },
    { join: "digital-feedback-138", name: "Zones Visibility", x: 665, y: navButtonY, width: 51, height: navButtonHeight, category: "security_system" },
    { join: "digital-feedback-139", name: "Camera Visibility", x: 738, y: navButtonY, width: 62, height: navButtonHeight, category: "security_system" },

    { join: "digital-feedback-142", name: "Alarm Armed Away", x: column1X, y: 90, width: statusWidth, height: 105, group: "status", category: "security_system" },
    { join: "digital-feedback-143", name: "Alarm Disarmed & Ready", x: column1X, y: 90, width: statusWidth, height: 105, group: "status", category: "security_system" },
    { join: "digital-feedback-144", name: "Alarm Disarmed & Not Ready", x: column1X, y: 90, width: statusWidth, height: 105, group: "status", category: "security_system" },
    { join: "serial-feedback-21", name: "Alarm Status", x: column1X, y: 200, width: statusWidth, height: 22, category: "security_system" },
    { join: "serial-feedback-20", name: "Alarm Status Message", x: column1X, y: 230, width: statusWidth, height: 22, category: "security_system" },

    { join: "digital-press-Security.SecurityKeypad.Press1", name: "Pinpad 1", x: column1X, y: row1Y, width: pinpadWidth, height: pinpadHeight, category: "security_system" },
    { join: "digital-press-Security.SecurityKeypad.Press2", name: "Pinpad 2", x: column2X, y: row1Y, width: pinpadWidth, height: pinpadHeight, category: "security_system" },
    { join: "digital-press-Security.SecurityKeypad.Press3", name: "Pinpad 3", x: column3X, y: row1Y, width: pinpadWidth, height: pinpadHeight, category: "security_system" },
    { join: "digital-press-Security.SecurityKeypad.Press4", name: "Pinpad 4", x: column1X, y: row2Y, width: pinpadWidth, height: pinpadHeight, category: "security_system" },
    { join: "digital-press-Security.SecurityKeypad.Press5", name: "Pinpad 5", x: column2X, y: row2Y, width: pinpadWidth, height: pinpadHeight, category: "security_system" },
    { join: "digital-press-Security.SecurityKeypad.Press6", name: "Pinpad 6", x: column3X, y: row2Y, width: pinpadWidth, height: pinpadHeight, category: "security_system" },
    { join: "digital-press-Security.SecurityKeypad.Press7", name: "Pinpad 7", x: column1X, y: row3Y, width: pinpadWidth, height: pinpadHeight, category: "security_system" },
    { join: "digital-press-Security.SecurityKeypad.Press8", name: "Pinpad 8", x: column2X, y: row3Y, width: pinpadWidth, height: pinpadHeight, category: "security_system" },
    { join: "digital-press-Security.SecurityKeypad.Press9", name: "Pinpad 9", x: column3X, y: row3Y, width: pinpadWidth, height: pinpadHeight, category: "security_system" },
    { join: "digital-press-Security.SecurityKeypad.PressStar", name: "Pinpad *", x: column1X, y: row4Y, width: pinpadWidth, height: pinpadHeight, category: "security_system" },
    { join: "digital-press-Security.SecurityKeypad.Press0", name: "Pinpad 0", x: column2X, y: row4Y, width: pinpadWidth, height: pinpadHeight, category: "security_system" },
    { join: "digital-press-Security.SecurityKeypad.PressHash", name: "Pinpad #", x: column3X, y: row4Y, width: pinpadWidth, height: pinpadHeight, category: "security_system" },
    { join: "digital-press-141", name: "Arm Home", x: 1090, y: actionButtonY, width: 80, height: actionButtonHeight, category: "security_system" },
    { join: "digital-press-142", name: "Arm Away", x: 1172, y: actionButtonY, width: 73, height: actionButtonHeight, category: "security_system" },
];

export default securitySystem;
